module.exports = __webpack_public_path__ + "img/19.d0530b89.png";